import { SoundConstant, SoundConstant as SoundConstantBehavior } from "@quest/murka-games-behavior-panther/dist";

export class SoundConstantGame extends SoundConstantBehavior {
  //big win sound
    public static readonly BIG_WIN_SLOT:string = "big_win_slot";
    public static readonly INTRO_BIG_WIN:string = "intro_big_win";
    public static readonly INTRO_CRAZY_WIN:string = "intro_crazy_win";
    public static readonly INTRO_EPIC_WIN:string = "intro_epic_win";
    public static readonly INTRO_SUPER_WIN:string = "intro_super_win";
  
    //basegame sound
    public static readonly LETTER_DROP_SOUND:string = "special_drop_1";
    public static readonly KEY_DROP_SOUND:string = "special_drop_2";
    public static readonly MAGNIFY_DROP_SOUND:string = "special_drop_3";
    public static readonly LANTERN_ICON_DROP:string = "lantern_icon_drop";
    public static readonly LANTERN_ICON_WIN:string = "lantern_icon_win";
    public static readonly SYMBOL_EXPLODE_SOUND: string = "match-3";
    public static readonly SPECIAL_PB_FILL:string = "special_pb_fill";
    public static readonly SPECIAL_PB_WIN:string = "special_pb_win";

    //dialouge banner sound
    public static readonly CHAR_APPEAR:string = "char_appear";
    public static readonly DIALOGUE_CLOUD_SOUND: string = "dialogue_cloud";
    public static readonly HIGHTLIGHT_1:string = "highlighted1";
    public static readonly HIGHTLIGHT_2:string = "highlighted2";
    public static readonly HIGHTLIGHT_3:string = "highlighted3";
    public static readonly HIGHTLIGHT_4:string = "highlighted4";
    public static readonly HIGHTLIGHT_5_1:string = "highlighted5_1";
    public static readonly HIGHTLIGHT_5_2:string = "highlighted5_2";
    public static readonly HIGHTLIGHT_5_3:string = "highlighted5_3";
    public static readonly HIGHTLIGHT_6:string = "highlighted6";
    public static readonly HIGHTLIGHT_7:string = "highlighted7";
    public static readonly HIGHTLIGHT_8:string = "highlighted8";
    public static readonly HIGHTLIGHT_9:string = "highlighted9";
    public static readonly HIGHTLIGHT_10:string = "highlighted10";

    public static readonly CHAR_DISUNITE:string = "char_disunite";

    //money hunting sound
    public static readonly COIN_COLLECTOR_WIN:string = "coin_collector_win_1";
    public static readonly MULTIPLIER_WIN:string = "multiplier_win";
    public static readonly COLLECTOR_WIN:string = "collector";
    public static readonly COINS_APPEAR_SOUND:string = "coins_collector_multiplier_spawn";
    public static readonly PLATE_WIN:string = "plate_win";
     // FREE SPIN PROGRESS SOUND EFFECTS 
    public static readonly FREE_SPIN_PROGRESS_1: string = "fs_pb_fill_1";
    public static readonly FREE_SPIN_PROGRESS_2: string = "fs_pb_fill_2";
    public static readonly FREE_SPIN_PROGRESS_3: string = "fs_pb_fill_3";
    public static readonly FREE_SPIN_PROGRESS_4: string = "fs_pb_fill_4";
    public static readonly FREE_SPIN_PROGRESS_5: string = "fs_pb_fill_5";
    public static readonly FREE_SPIN_PROGRESS_6: string = "fs_pb_fill_6";
    public static readonly FREE_SPIN_PROGRESS_7: string = "fs_pb_fill_7";
    public static readonly FREE_SPIN_WIN: string = "fs_pb_win";
    public static readonly CHARACTER_WIN_SOUND: string = "character_win";

    //bonus feature
    public static readonly GRNAD_YOU_WON:string = "grand_you_won";
    public static readonly CLUE_YOU_WON:string = "clue_you_won";
    public static readonly CLUE_REVEAL:string = "clue_reveal";
    public static readonly ALL_CLUE_REVEALED:string = "all_clue_win";
    public static readonly BONUS_FEATURE_BG: string = "music_bg";

}

SoundConstant.WIN_SOUND_FG_3 = "free_spins_custom_win";
SoundConstant.FREE_GAME_INTRO = "popup_fs_start";
SoundConstant.RETRIGGER_POP_UP_SOUND = "popup_fs_start";
SoundConstant.FREE_GAME_OUTRO = "popup_fs_end";
